'use client';

import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import UploadIcon from '@/public/icons/add_photo.svg';

interface UploadButtonProps {
  disabled: boolean;
  isMultiple: boolean;
  buttonText: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
}

const styles = {
  buttonTextDisabled: 'text-label-secondary',
  buttonIcon: 'absolute left-5 w-5.5',
  button:
    'sticky bottom-10 w-full left-5 right-5 bg-fill-button rounded-xl py-5 mt-8 block cursor-pointer',
  buttonDisabled: 'bg-fill-toast cursor-not-allowed',
  buttonText: 'text-label-black font-extrabold text-base text-center',
};

export const UploadButton: FC<UploadButtonProps> = ({
  disabled,
  buttonText,
  onChange,
  onClick,
  isMultiple = false,
}) => (
  <label className={styles.button}>
    <UploadIcon className={styles.buttonIcon} />
    <div
      className={twMerge(
        styles.buttonText,
        disabled && styles.buttonTextDisabled,
      )}
    >
      {buttonText}
    </div>
    <input
      onClick={onClick}
      type="file"
      accept="image/*"
      multiple={isMultiple}
      onChange={onChange}
      style={{ display: 'none' }}
    />
  </label>
);
